import { Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';

@Component({
  selector: 'app-datasource-link-icon',
  templateUrl: './datasource-link-icon.component.html',
  styleUrls: ['./datasource-link-icon.component.css']
})
export class DatasourceLinkIconComponent implements ICellRendererAngularComp {
  params: ICellRendererParams;
  agRowData: any;
  @Input() status = false;

  constructor() {}

  get iconStatus() {
    return this.params?.data.isLinked || this.status;
  }

  get toolTip() {
    let label = '';
    if(this.params?.data) {
      const data = this.params.data;
      label = `${data.dsTypeName} > ${data.dsName} > ${data.dsNodeTagName}`
    }
    return label;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.agRowData = params.node.data;
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    return true;
  }

  linkIconClicked() {
    if(this.params.context?.parentComponent) {
      this.params.context.parentComponent.triggerAction(this.params.data);
    }
  }
}
